import { $, $$ } from "../libraries/utils"

window.colissmoRelaySelectedCallback = function () {
    $$(".js-pickup-address input").forEach(function (scElement) {
        const colissimoElem = $(`#${scElement.dataset.colissimoId}`)
        // TODO handle elem not found
        scElement.value = colissimoElem.value
        // Trigger Livewire sync
        scElement.dispatchEvent(new Event("input"))
    })
    $(".js-shipping-method button[type=submit]").click()
}
